module.exports = __webpack_public_path__ + "img/ml.a2bde944.svg";